/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'fabric.elements.mentions.team.member.50plus': 'Tiimi • 50+ jäsentä',
  'fabric.elements.mentions.team.member.50plus.including.you': 'Tiimi • 50+ jäsentä sinä mukaan lukien',
  'fabric.elements.mentions.team.member.count': '{0, plural, one {Tiimi • 1 jäsen} other {Tiimi • {0} jäsentä}}',
  'fabric.elements.mentions.team.member.count.including.you':
    '{0, plural, one {Tiimi • 1 jäsen sinä mukaan lukien} other {Tiimi • {0} jäsentä sinä mukaan lukien}}',
  'fabric.elements.mentions.xproduct.mention.description': 'Tarvitsee Confluence-käyttöoikeuden',
  'fabric.mention.error.defaultAction': 'Yritä uudelleen hetken kuluttua',
  'fabric.mention.error.defaultHeadline': 'Jotain meni pieleen',
  'fabric.mention.error.differentText': 'Kirjoita eri teksti',
  'fabric.mention.error.loginAgain': 'Kirjaudu ulos ja sitten uudelleen sisään',
  'fabric.mention.noAccess.label': 'Ei pääsyä',
  'fabric.mention.noAccess.warning': '{name} ei saa ilmoitusta, koska hänellä ei ole pääsyä',
  'fabric.mention.unknow.user.error': 'Tuntematon käyttäjä {userId}',
};
